import { useState } from 'react';
import Footer from '../home/components/Footer';

export default function Privacy() {
  const [activeSection, setActiveSection] = useState('home');

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId);
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/')}
              className="flex items-center space-x-2 cursor-pointer"
            >
              <i className="ri-building-4-line text-2xl text-emerald-700"></i>
              <span className="text-xl font-bold text-emerald-900">合同会社フジワン</span>
            </button>
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                ホーム
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                サービス
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                会社概要
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-emerald-700 text-white px-6 py-2 rounded-full hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                お問い合わせ
              </button>
            </div>
            <button className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className="ri-menu-line text-2xl text-gray-700"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-8">
            プライバシーポリシー
          </h1>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <p className="text-gray-600 leading-relaxed">
                合同会社フジワン（以下「当社」といいます）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーを定め、適切な取り扱いと保護に努めます。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">1. 個人情報の定義</h2>
              <p className="text-gray-600 leading-relaxed">
                個人情報とは、お客様個人に関する情報であって、氏名、住所、電話番号、メールアドレスなど、特定の個人を識別できる情報をいいます。また、他の情報と容易に照合することができ、それにより特定の個人を識別することができる情報も含まれます。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">2. 個人情報の収集</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                当社は、以下の目的のために必要な範囲で個人情報を収集します。
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供および改善</li>
                <li>見積もりの作成および提案</li>
                <li>契約の履行</li>
                <li>アフターサービスの提供</li>
                <li>各種ご案内やお知らせの送付</li>
              </ul>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">3. 個人情報の利用目的</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                当社は、収集した個人情報を以下の目的で利用します。
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>お客様からのお問い合わせに対する回答</li>
                <li>サービスの提供、運営、維持、改善</li>
                <li>お客様への連絡、情報提供</li>
                <li>契約内容の確認および履行</li>
                <li>請求書の発行および代金の請求</li>
                <li>マーケティング活動および統計分析</li>
              </ul>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">4. 個人情報の第三者提供</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
              </ul>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">5. 個人情報の管理</h2>
              <p className="text-gray-600 leading-relaxed">
                当社は、個人情報の正確性を保ち、これを安全に管理します。個人情報への不正アクセス、紛失、破壊、改ざん、漏洩などを防止するため、適切なセキュリティ対策を実施します。また、個人情報は、利用目的の達成に必要な期間のみ保管し、不要となった場合は速やかに削除または廃棄します。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">6. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-600 leading-relaxed">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、削除を請求することができます。請求される場合は、当社までご連絡ください。ただし、法令に基づき開示できない場合があります。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">7. Cookie（クッキー）の使用</h2>
              <p className="text-gray-600 leading-relaxed">
                当社のウェブサイトでは、サービスの利便性向上のためにCookieを使用する場合があります。Cookieとは、ウェブサイトがお客様のコンピュータに送信する小さなテキストファイルです。お客様は、ブラウザの設定によりCookieの受け取りを拒否することができますが、その場合、一部のサービスが利用できなくなる可能性があります。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">8. プライバシーポリシーの変更</h2>
              <p className="text-gray-600 leading-relaxed">
                当社は、法令の変更や事業内容の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section className="bg-white p-8 shadow-sm border-l-4 border-emerald-700">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">9. お問い合わせ窓口</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。
              </p>
              <div className="bg-emerald-50 p-6 rounded-lg">
                <p className="text-gray-800 font-semibold mb-2">合同会社フジワン</p>
                <p className="text-gray-600">〒344-0016</p>
                <p className="text-gray-600">埼玉県春日部市藤塚1897番地4</p>
                <p className="text-gray-600 mt-2">営業時間：平日 9:00 - 18:00</p>
              </div>
            </section>

            <section className="text-right text-gray-600 mt-12">
              <p>合同会社フジワン</p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
